<script setup lang="ts">
import TypeTourMenuItem from "~/components/TypeTourMenuItem.vue";
import type { Hero, TourType } from "~/types/general";
import gsap from "gsap";
import { useRoute } from "vue-router";

const route = useRoute();

const tours = useTourStore();
tours.fetchTourTypes();

const hero = useThemeStore();
const heroData = hero.getHero;

const wishList: TourType = {
  title: "Wish List",
  icon: "/icons/IconWishList2.svg",
  slug: "wishlist",
};

const main = ref<HTMLElement | null>(null);
let tl: gsap.core.Timeline;
let ctx: gsap.Context;

onMounted(() => {
  ctx = gsap.context((self) => {
    const el = document.querySelector(".subtitle") as HTMLElement;

    let index = 1;

    const animateContent = () => {
      tl = gsap.timeline();
      tl.to(el as gsap.TweenTarget, {
        opacity: 0,
        duration: 3,
        onComplete: function () {
          el.innerHTML = heroData.subtitle[index]; // Change the content of the element
          gsap.to(el as gsap.TweenTarget, {
            opacity: 1,
            duration: 3,
            onComplete: function () {
              index = (index + 1) % heroData.subtitle.length; // Loop through the array
              animateContent(); // Call the function again to loop
            },
          });
        },
      });
    };

    animateContent(); // Start the animation
  });
});

onUnmounted(() => {
  ctx.revert(); // <- Easy Cleanup!
});
</script>

<template>
  <section class="hero relative flex h-[400px]" ref="main">
    <div
      style="background-image: url(&quot;../images/hero-1.jpg&quot;)"
      class="absolute top-0 bottom-0 left-0 right-0 z-0 bg-cover"
    >
      <div class="flex flex-col justify-between h-full">
        <div class="h-24 bg-gradient-to-b-black">
          <TopNavigation />
        </div>
        <div>
          <div class="bg-gradient-to-t-black">
            <div class="px-3 pb-8">
              <span
                class="hero-title bg-primary text-2xl font-extrabold text-white"
                >{{
                  route.path.startsWith("/alltour")
                    ? "All Tour"
                    : heroData.title
                }}</span
              >
              <div class="text-xl text-white max-w-60">
                <p class="subtitle">{{ heroData.subtitle[0] }}</p>
              </div>
            </div>
            <nav
              class="flex gap-8 overflow-x-auto first-of-type:pl-5 last-of-type:pr-5"
            >
              <TypeTourMenuItem
                v-for="item in tours.getTourTypes"
                :key="item.slug"
                :item="item"
              />
              <!-- <TypeTourMenuItem :item="wishList" /> -->

              <NuxtLink
                :to="'/wishlist'"
                class="group flex cursor-pointer flex-col items-center justify-center"
              >
                <svg
                  width="36"
                  class="h-8 w-8 translate-y-1 group-hover:translate-y-1.5"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27 14.25C27 11.7647 24.9013 9.75 22.3125 9.75C20.3769 9.75 18.7153 10.8763 18 12.4834C17.2847 10.8763 15.6231 9.75 13.6875 9.75C11.0987 9.75 9 11.7647 9 14.25C9 21.4706 18 26.25 18 26.25C18 26.25 27 21.4706 27 14.25Z"
                    stroke="#D9D9D9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <span class="text-white">wishList</span>
                <svg
                  width="61"
                  height="5"
                  viewBox="0 0 61 5"
                  fill="none"
                  class="group-hover:fill-primary"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.5 5C0.5 2.23858 2.73858 0 5.5 0H55.5C58.2614 0 60.5 2.23858 60.5 5H0.5Z"
                  />
                </svg>
              </NuxtLink>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
